import isHotkey from 'is-hotkey';
import styled from 'styled-components';
import Icon, { IconType } from 'src/components/icon';
import { NoneButton } from 'styles-js/buttons';
export type ButtonType = Extract<IconType, 'bold' | 'italic' | 'underline' | 'picture' | 'at' | 'smile'>;
type Props = {
  aria: string;
  dataTestId?: string;
  format: ButtonType;
  htmlFor?: string;
  isActive: boolean;
  toggleMark: (format: ButtonType) => void;
};
export default function MarkButton({
  format,
  toggleMark,
  aria,
  isActive,
  htmlFor,
  dataTestId
}: Props) {
  if (format === 'picture') {
    return <IconButton aria-label={aria} as="label" className={isActive ? 'active' : ''} data-testid="image-upload" htmlFor={htmlFor} onKeyDown={event => {
      const key = event.key;
      if (isHotkey(key, event) && key === 'Enter') {
        event.preventDefault();
        toggleMark(format);
      }
    }} onMouseDown={event => {
      event.preventDefault();
      toggleMark(format);
    }}>
        <Icon icon={format} />
      </IconButton>;
  }
  return <IconButton aria-label={aria} className={isActive ? 'active' : ''} data-testid={dataTestId} onKeyDown={event => {
    const key = event.key;
    if (isHotkey(key, event) && key === 'Enter') {
      event.preventDefault();
      toggleMark(format);
    }
  }} onMouseDown={event => {
    event.preventDefault();
    toggleMark(format);
  }} data-sentry-element="IconButton" data-sentry-component="MarkButton" data-sentry-source-file="buttons.tsx">
      <StyledLabel htmlFor={htmlFor} data-sentry-element="StyledLabel" data-sentry-source-file="buttons.tsx">
        <Icon icon={format} data-sentry-element="Icon" data-sentry-source-file="buttons.tsx" />
      </StyledLabel>
    </IconButton>;
}
const IconButton = styled(NoneButton)`
  padding: 0 10px;
  border: none;
  color: ${props => props.theme.colorGreyDark};
  font-size: 23px;
  transition: none;
  cursor: pointer; // when IconButton is a label for image upload item
  // iOS hover doesn't turn off
  &:hover { // set hover to default colour
    color: ${props => props.theme.colorGreyDark};
  }
  @media (hover: hover) and (${props => props.theme.overScreenSmall}) { // only use hover colour if supported by browser - and if not a phone !
    &:hover {
      color: ${props => props.theme.colorBlue};
    }
  }
  &.active {
    color: ${props => props.theme.colorBlue};
  }
  @media (${props => props.theme.underScreenSmall}) {
    padding: 0 9px;
  }
`;
const StyledLabel = styled.label`
  cursor: pointer;
  margin-bottom: 0;
`;